import { invokeApi } from '../utils/api';
import { $axios, $axiosWithToken } from '../utils/axios';

export const me = () =>
  invokeApi($axiosWithToken, '/users/me')
    .then((resp) => resp)
    .catch((err) => {
      throw err;
    });

export const adminLogin = (data) =>
  invokeApi($axios, '/auth/local', data, 'POST')
    .then((resp) => resp)
    .catch((err) => {
      throw err;
    });
